  (() => {
    const nextContentElement = (element) => {
      let next = element.nextElementSibling;
      while (next && (
        next.tagName === 'BR' ||
        (next.tagName === 'P' && !next.textContent.trim() && !next.querySelector('img, video, iframe, svg'))
      )) {
        next.classList.add('mp-article__faq-spacer');
        next = next.nextElementSibling;
      }
      return next;
    };

    const decorateArticleContent = (content) => {
      content.querySelectorAll("[data-mp-seo='gsc-faq-v1'] p").forEach((paragraph) => {
        const strong = paragraph.firstElementChild;
        if (!strong || strong.tagName !== 'STRONG' || !strong.textContent.trim().startsWith('--')) return;
        paragraph.classList.add('mp-article__faq-question');
        const answer = nextContentElement(paragraph);
        if (answer && answer.tagName === 'P') answer.classList.add('mp-article__faq-answer');
      });
    };

    const initArticleToc = (root) => {
      if (!root || root.dataset.mpTocReady === 'true') return;
      const content = root.querySelector('[data-mp-article-content]');
      const tocBlocks = Array.from(root.querySelectorAll('[data-mp-toc]'));
      if (!content) return;

      decorateArticleContent(content);
      if (tocBlocks.length === 0) {
        root.dataset.mpTocReady = 'true';
        return;
      }

      const headings = Array.from(content.querySelectorAll('h2')).filter((heading) => heading.textContent.trim());
      if (headings.length === 0) {
        root.dataset.mpTocReady = 'true';
        return;
      }

      const usedIds = new Set(Array.from(document.querySelectorAll('[id]')).map((element) => element.id));
      headings.forEach((heading, index) => {
        if (!heading.id) {
          const base = heading.textContent
            .trim()
            .toLowerCase()
            .replace(/ß/g, 'ss')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '') || `abschnitt-${index + 1}`;
          let candidate = `mp-${base}`;
          let suffix = 2;
          while (usedIds.has(candidate)) candidate = `mp-${base}-${suffix++}`;
          heading.id = candidate;
          usedIds.add(candidate);
        }
      });

      const tocLinks = [];
      const setActiveHeading = (heading) => {
        tocLinks.forEach(({ link, target }) => {
          if (target === heading) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };

      tocBlocks.forEach((tocBlock) => {
        const list = tocBlock.querySelector('[data-mp-toc-list]');
        if (!list) return;
        headings.forEach((heading) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent.trim();
          link.addEventListener('click', (event) => {
            if (!event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
              event.preventDefault();
              heading.scrollIntoView({
                behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
                block: 'start'
              });
              if (window.location.hash !== link.hash) window.history.pushState(null, '', link.hash);
              setActiveHeading(heading);
            }
            const details = link.closest('details');
            if (details) details.open = false;
          });
          tocLinks.push({ link, target: heading });
          item.appendChild(link);
          list.appendChild(item);
        });
        tocBlock.hidden = false;
      });

      let initialHeading = headings[0];
      if (window.location.hash) {
        try {
          initialHeading = headings.find((heading) => heading.id === decodeURIComponent(window.location.hash.slice(1))) || initialHeading;
        } catch (error) {
          initialHeading = headings[0];
        }
      }
      setActiveHeading(initialHeading);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          const visibleHeading = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
          if (visibleHeading) setActiveHeading(visibleHeading.target);
        }, { rootMargin: '-24px 0px -72% 0px', threshold: 0 });
        headings.forEach((heading) => observer.observe(heading));
      }

      root.dataset.mpTocReady = 'true';
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-mp-article]').forEach(initArticleToc);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
